import { render, staticRenderFns } from "./InsuranceTable.vue?vue&type=template&id=6dea5708&scoped=true"
import script from "./InsuranceTable.vue?vue&type=script&lang=js"
export * from "./InsuranceTable.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTable.vue?vue&type=style&index=0&id=6dea5708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea5708",
  null
  
)

export default component.exports